import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import Moment from 'moment';
import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Select, getActiveLanguage } from '@haldor/ui';

var DatePickers = /*#__PURE__*/function (_Component) {
  _inherits(DatePickers, _Component);

  var _super = _createSuper(DatePickers);

  function DatePickers(props) {
    var _this;

    _classCallCheck(this, DatePickers);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onStartChange", function (time) {
      var _this$state = _this.state,
          dtPickerStartDate = _this$state.dtPickerStartDate,
          startDate = _this$state.startDate;

      if (time != "Invalid date" && time != null) {
        dtPickerStartDate = Moment(time);
        startDate = Moment(time).format('YYYY-MM-DD');

        _this.setState({
          dtPickerStartDate: dtPickerStartDate,
          startDate: startDate
        }, function () {
          _this.onChange();
        });
      } else {
        var dStartDate = Moment();

        var _startDate2 = Moment().format('YYYY-MM-DD');

        var dDueDate = Moment();
        var dueDate = Moment().format('YYYY-MM-DD');

        _this.setState({
          dtPickerStartDate: dStartDate,
          dtPickerDueDate: dDueDate,
          startDate: _startDate2,
          endDate: dueDate
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onEndChange", function (time) {
      var _this$state2 = _this.state,
          dtPickerDueDate = _this$state2.dtPickerDueDate,
          endDate = _this$state2.endDate;

      if (time != "Invalid date" && time != null) {
        dtPickerDueDate = Moment(time);
        endDate = Moment(time).format('YYYY-MM-DD');

        _this.setState({
          dtPickerDueDate: dtPickerDueDate,
          endDate: endDate
        }, function () {
          _this.onChange();
        });
      } else {
        var dDueDate = Moment();
        var dueDate = Moment().format('YYYY-MM-DD');

        _this.setState({
          dtPickerDueDate: dDueDate,
          endDate: dueDate
        }, function () {
          _this.onChange();
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onTermChange", function (value) {
      if (value != '') {
        var dStartDate = Moment();
        var startDate = Moment().format('YYYY-MM-DD');
        var dDueDate = Moment();
        var dueDate = Moment().format('YYYY-MM-DD');

        switch (value) {
          case 'year':
            if (Moment().month() < 7) {
              dStartDate = Moment().subtract(1, 'year').month(7).date(1);
              startDate = Moment().subtract(1, 'year').month(7).date(1).format('YYYY-MM-DD');
              dDueDate = Moment().month(6).date(31);
              dueDate = Moment().month(6).date(31).format('YYYY-MM-DD');
            } else {
              dStartDate = Moment().month(7).date(1);
              startDate = Moment().month(7).date(1).format('YYYY-MM-DD');
              dDueDate = Moment().add(1, 'year').month(6).date(31);
              dueDate = Moment().add(1, 'year').month(6).date(31).format('YYYY-MM-DD');
            }

            break;

          case 'previous-year':
            if (Moment().month() < 7) {
              dStartDate = Moment().subtract(2, 'year').month(7).date(1);
              startDate = Moment().subtract(2, 'year').month(7).date(1).format('YYYY-MM-DD');
              dDueDate = Moment().subtract(1, 'year').month(6).date(31);
              dueDate = Moment().subtract(1, 'year').month(6).date(31).format('YYYY-MM-DD');
            } else {
              dStartDate = Moment().subtract(1, 'year').month(7).date(1);
              startDate = Moment().subtract(1, 'year').month(7).date(1).format('YYYY-MM-DD');
              dDueDate = Moment().subtract(0, 'year').month(6).date(31);
              dueDate = Moment().subtract(0, 'year').month(6).date(31).format('YYYY-MM-DD');
            }

            break;

          case 'semester':
            if (Moment().month() < 7) {
              dStartDate = Moment().month(0).date(1);
              startDate = Moment().month(0).date(1).format('YYYY-MM-DD');
              dDueDate = Moment().month(6).date(31);
              dueDate = Moment().month(6).date(31).format('YYYY-MM-DD');
            } else {
              dStartDate = Moment().month(6).date(1);
              startDate = Moment().month(6).date(1).format('YYYY-MM-DD');
              dDueDate = Moment().month(11).date(31);
              dueDate = Moment().month(11).date(31).format('YYYY-MM-DD');
            }

            break;
        }

        _this.setState({
          dtPickerStartDate: dStartDate,
          dtPickerDueDate: dDueDate,
          startDate: startDate,
          endDate: dueDate
        }, function () {
          _this.onChange();
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function () {
      if (_this.props.onChange) {
        var dates = {
          start: _this.state.startDate,
          end: _this.state.endDate
        };

        _this.props.onChange(dates);
      }
    });

    Moment.locale(getActiveLanguage());

    var _dStartDate;

    var _dDueDate;

    var _startDate;

    var _dueDate;

    if (props.startDate != null) {
      _dStartDate = Moment(props.startDate);
      _startDate = props.startDate;
    } else {
      _dStartDate = Moment();
      _startDate = Moment().format('YYYY-MM-DD');
    }

    if (props.endDate != null) {
      _dDueDate = Moment(props.endDate);
      _dueDate = props.endDate;
    } else {
      _dDueDate = Moment();
      _dueDate = Moment().format('YYYY-MM-DD');
    }

    _this.state = {
      dtPickerStartDate: _dStartDate,
      dtPickerDueDate: _dDueDate,
      startDate: _startDate,
      endDate: _dueDate
    };
    return _this;
  }

  _createClass(DatePickers, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row-half static"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "date-start",
        style: {
          marginTop: 0
        }
      }, this.props.translate('start')), /*#__PURE__*/React.createElement(DatePicker, _extends({
        selected: this.state.dtPickerStartDate,
        startDate: this.state.dtPickerStartDate,
        endDate: this.state.dtPickerDueDate,
        onChange: this.onStartChange,
        popperModifiers: {
          preventOverflow: {
            enabled: false
          },
          positionFixed: true
        },
        selectsStart: true,
        popperPlacement: "bottom-start",
        showWeekNumbers: true,
        fixedHeight: true,
        previousMonthButtonLabel: "",
        nextMonthButtonLabel: ""
      }, this.state.startDate))), /*#__PURE__*/React.createElement("div", {
        className: "form-row-half static last"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "date-end",
        style: {
          marginTop: 0
        }
      }, this.props.translate('end')), /*#__PURE__*/React.createElement(DatePicker, _extends({
        selected: this.state.dtPickerDueDate,
        startDate: this.state.dtPickerStartDate,
        endDate: this.state.dtPickerDueDate,
        minDate: this.state.dtPickerStartDate,
        onChange: this.onEndChange,
        popperModifiers: {
          preventOverflow: {
            enabled: true
          },
          positionFixed: true
        },
        popperPlacement: "bottom-start",
        selectsEnd: true,
        showWeekNumbers: true,
        fixedHeight: true,
        previousMonthButtonLabel: "",
        nextMonthButtonLabel: "",
        placeholderText: this.props.translate('today'),
        isClearable: true
      }, this.state.endDate))), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'inline-block'
        }
      }, /*#__PURE__*/React.createElement(Select, {
        onChange: this.onTermChange,
        options: [{
          label: this.props.translate('current-schoolyear'),
          value: 'year'
        }, {
          label: this.props.translate('previous-schoolyear'),
          value: 'previous-year'
        }, {
          label: this.props.translate('current-semester'),
          value: 'semester'
        }]
      }, this.props.translate('select-period')))));
    }
  }]);

  return DatePickers;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    languages: state.Languages.languages
  };
}

export default connect(mapStateToProps)(DatePickers);